import { gql } from '@apollo/client';

export const UPDATE_CUSTOMER = gql`
  mutation PatchCustomer($input: PatchCustomerInput!) {
    patchCustomer(input: $input) {
      uid
      language
      preferredLanguage
      applicationPreferences {
        sendEmailReceipts
        alwaysSelectVehicle
      }
    }
  }
`;
